import React, {Fragment} from "react";
import PropTypes from "prop-types";
import Page from "../../components/BaseComponents/Page/Page";
import {FaSolidIcon} from "../../components/FontAwesomeIcons";
import FuxCursorPaginator from "../../components/BaseComponents/FuxCursorPaginator/FuxCursorPaginator";
import {UserEventItem} from "./UserEvent/UserEventItem";
import {UserPhotoAlbumItem} from "./UserPhotoAlbum/UserPhotoAlbumItem";
import {CreateEventPage} from "./CreateEvent/CreateEventPage";
import {UserEventPage} from "./UserEvent/UserEventPage";
import {UserPhotoAlbumPage} from "./UserPhotoAlbum/UserPhotoAlbumPage";
import {UsersModuleEventsAPI} from "../../api/UsersModuleEvents/UsersModuleEventsAPI";
import {UsersModulePhotoAlbumsAPI} from "../../api/UsersModulePhotoAlbums/UsersModulePhotoAlbumsAPI";
import {TabViewItem} from "../../components/BaseComponents/TabView";
import {USER_EVENT_TYPE_PHOTO_ALBUM} from "./CreateEvent/CreateEventConstants";

const TAB_EVENTS = "events";
const TAB_PHOTO_ALBUMS = "photo_albums";

export class UserModuleEventsPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            createEventPageOpen: false,
            eventPageOpen: false,
            showEventPagination: true,
            showPhotoAlbumPagination: true,
            photoAlbumPageOpen: false,
            eventOpenId: null,
            photoAlbumOpenId: null,
            activeTab: TAB_EVENTS,
        };
    }

    /**
     * USER EVENT TYPE
     */
    handleEventItemRender = item => <UserEventItem item={item} onClick={this.handleEventClick}/>

    handleEventsPageRequest = cursor => UsersModuleEventsAPI.Admin.Events.pagination(cursor)

    toggleCreateEventPage = _ => this.setState({
        createEventPageOpen: !this.state.createEventPageOpen,
        showEventPagination: false
    }, () => {
        if (!this.state.createEventPageOpen) {
            this.setState({showEventPagination: true})
        }
    })

    handleEventCreated = eventType => {
        if (eventType === USER_EVENT_TYPE_PHOTO_ALBUM) {
            this.setState({
                activeTab: TAB_PHOTO_ALBUMS,
                showPhotoAlbumPagination: false
            }, () => {
                this.setState({showPhotoAlbumPagination: true})
            });
            return;
        }

        this.setState({
            activeTab: TAB_EVENTS,
            showEventPagination: false
        }, () => {
            this.setState({showEventPagination: true})
        });
    }

    handleEventClick = event_id => {
        this.setState({
            eventOpenId: event_id,
            eventPageOpen: true
        })
    }
    handleEventPageDismiss = _ => {
        this.setState({
            eventOpenId: null,
            eventPageOpen: false,
            showEventPagination: false
        }, () => {
            this.setState({
                showEventPagination: true
            })
        })
    }

    /**
     * USER PHOTO ALBUM TYPE
     */
    handlePhotoAlbumItemRender = item => <UserPhotoAlbumItem item={item} onClick={this.handlePhotoAlbumClick}/>

    handlePhotoAlbumsPageRequest = cursor => UsersModulePhotoAlbumsAPI.Admin.Album.pagination(cursor)

    handleEmptyPhotoAlbumsPage = _ => (
        <div className={"text-center text-muted py-5"}>
            Non hai ancora creato album fotografici.
        </div>
    )

    handlePhotoAlbumClick = photo_album_id => {
        this.setState({
            photoAlbumOpenId: photo_album_id,
            photoAlbumPageOpen: true
        })
    }

    handlePhotoAlbumPageDismiss = _ => {
        this.setState({
            photoAlbumOpenId: null,
            photoAlbumPageOpen: false
        })
    }

    handleEmptyPage = _ => (
        <div className={"text-center text-muted py-5"}>
            Non hai ancora creato eventi.
        </div>
    )

    handleTabChange = tab => _ => this.setState({activeTab: tab})

    render() {
        return (
            <Fragment>
                <Page
                    title={"I tuoi eventi"}
                    leftIcon={<FaSolidIcon name={"chevron-left"}/>}
                    onLeftIconClick={this.props.onDismiss}
                    active={true}
                >
                    <div className={"container py-3"}>
                        <button
                            type={"button"}
                            className={"btn btn-light btn-block text-left shadow-sm border-0 mb-4 p-3"}
                            onClick={this.toggleCreateEventPage}
                        >
                            <div className={"d-flex align-items-center justify-content-between"}>
                                <div className={"d-flex align-items-center"}>
                                    <div className={"rounded bg-primary text-white d-flex align-items-center justify-content-center p-2 mr-3"}>
                                        <FaSolidIcon name={"calendar-plus"}/>
                                    </div>
                                    <div>
                                        <div className={"font-weight-bold text-dark"}>Crea un nuovo evento</div>
                                        <div className={"small text-muted"}>
                                            Gestisci adesioni, album foto, QR code e pagina evento
                                        </div>
                                    </div>
                                </div>
                                <FaSolidIcon name={"chevron-right"} className={"text-muted ml-3"}/>
                            </div>
                        </button>

                        <div className={"d-flex bg-white shadow-sm mb-3"}>
                            <TabViewItem
                                onClick={this.handleTabChange(TAB_EVENTS)}
                                className={"py-2 text-muted d-flex align-items-center justify-content-center flex-fill text-uppercase " + (this.state.activeTab === TAB_EVENTS ? " active" : "")}
                                activeColor={"#293069"}
                            >
                                Eventi
                            </TabViewItem>
                            <TabViewItem
                                onClick={this.handleTabChange(TAB_PHOTO_ALBUMS)}
                                className={"py-2 text-muted d-flex align-items-center justify-content-center flex-fill text-uppercase " + (this.state.activeTab === TAB_PHOTO_ALBUMS ? " active" : "")}
                                activeColor={"#293069"}
                            >
                                Album fotografico
                            </TabViewItem>
                        </div>

                        {
                            this.state.activeTab === TAB_EVENTS && this.state.showEventPagination &&
                            <FuxCursorPaginator
                                onItemRender={this.handleEventItemRender}
                                onPageRequest={this.handleEventsPageRequest}
                                onEmptyPage={this.handleEmptyPage}
                            />
                        }

                        {
                            this.state.activeTab === TAB_PHOTO_ALBUMS && this.state.showPhotoAlbumPagination &&
                            <FuxCursorPaginator
                                onItemRender={this.handlePhotoAlbumItemRender}
                                onPageRequest={this.handlePhotoAlbumsPageRequest}
                                onEmptyPage={this.handleEmptyPhotoAlbumsPage}
                            />
                        }
                    </div>
                </Page>

                {
                    this.state.createEventPageOpen &&
                    <CreateEventPage
                        onCreated={this.handleEventCreated}
                        onDismiss={this.toggleCreateEventPage} />
                }

                {
                    this.state.eventPageOpen &&
                    <UserEventPage
                        eventId={this.state.eventOpenId}
                        onDismiss={this.handleEventPageDismiss}
                    />
                }

                {
                    this.state.photoAlbumPageOpen &&
                    <UserPhotoAlbumPage
                        photoAlbumId={this.state.photoAlbumOpenId}
                        onDismiss={this.handlePhotoAlbumPageDismiss}
                    />
                }

            </Fragment>
        );
    }
}

UserModuleEventsPage.propTypes = {
    onDismiss: PropTypes.func,
};
